module.exports = __webpack_public_path__ + "img/FPT21.fca0a126.svg";